import type { ReactElement } from 'react';

import type { TextFieldProps } from '@mui/material/TextField';
import type { FieldError } from 'react-hook-form';

import TextField from '@mui/material/TextField';

type SharedTextFieldProps = Partial<Omit<TextFieldProps, 'error'>> & {
    error?: FieldError;
    readOnly?: boolean;
};

const SharedTextField = ({
    required = true,
    readOnly = false,
    ...props
}: SharedTextFieldProps): ReactElement => (
    <TextField
        {...props}
        label={props.label}
        placeholder="Select"
        error={!!props.error}
        helperText={props.error ? props.error.message : null}
        required={required}
        slotProps={{
            ...props.slotProps,
            input: {
                // eslint-disable-next-line @typescript-eslint/no-misused-spread
                ...props.slotProps?.input,
                readOnly: readOnly,
                ...(readOnly && { endAdornment: null }), // Will hide the dropdown icon when readOnly is true
            },
            inputLabel: {
                sx: {
                    // We want to balance labels because we can have quite narrow columns
                    textWrap: 'balance',
                },
            },
        }}
    />
);

export { SharedTextField };
